export const configConstants = {
    GETALL_REQUEST: 'CONFIG_GETALL_REQUEST',
    GETACTIVE_CUSTOMERS_REQUEST: 'CONFIG_GETACTIVE_CUSTOMERS_REQUEST',
    GETALL_CUSTOMERS_SUCCESS: 'CONFIG_CUSTOMERS_GETALL_SUCCESS',
    GETACTIVE_CUSTOMERS_SUCCESS: 'CONFIG_CUSTOMERS_GETACTIVE_SUCCESS',
    GETALL_CHANNELS_SUCCESS: 'CONFIG_CHANNELS_GETALL_SUCCESS',
    GETALL_FAILURE: 'CONFIG_GETALL_FAILURE',

    GET_ALL_CUSTOMER_REQUEST: 'CONFIG_CUSTOMER_GETALL_REQUEST',

    GET_FILES_PROJECTS_SUCCESS: 'CONFIG_FILES_PROJECTS_GET_SUCCESS',
    GET_DOCS_PROJECTS_SUCCESS: 'CONFIG_DOCS_PROJECTS_GET_SUCCESS',
    GET_EXEC_REPORTS_PROJECTS_SUCCESS: 'CONFIG_REPORTS_EXEC_PROJECTS_GET_SUCCESS',
    GET_CONFIG_REPORTS_PROJECTS_SUCCESS: 'CONFIG_REPORTS_CONFIG_PROJECTS_GET_SUCCESS',
    GET_DASHBOARD_PROJECTS_SUCCESS: 'CONFIG_DASHBOARD_PROJECTS_GET_SUCCESS',
    GET_WIZARD_PROJECTS_SUCCESS: 'CONFIG_WIZARD_PROJECTS_GET_SUCCESS',

    FILTER_PROJECTS_BY_CUSTOMERID: 'CONFIG_FILTER_PROJECTS_BY_CUSTOMERID',

    GET_CUSTOMER_CONFIG_REPORTS_SUCCESS: 'CONFIG_GET_CUSTOMER_CONFIG_REPORTS_SUCCESS',
    SET_SELE_CUST_CONFIG_REPOPRTS_PAGE_NUMBER: 'CONFIG_SET_SELE_CUST_CONFIG_REPOPRTS_PAGE_NUMBER',

    SET_CUSTOMER_CONFIG_REPORT_ACTIVE_ROW: 'CONFIG_SET_CUSTOMER_CONFIG_REPORT_ACTIVE_ROW',

    RESET_VIEWS_PROJECTS: 'CONFIG_RESET_VIEWS_PROJECTS',

    RESET_DOCS_ACTIVE_TAB: 'CONFIG_RESET_DOCS_ACTIVE_TAB',
    TOGGLE_DOCS_ACTIVE_TAB: 'CONFIG_TOGGLE_DOCS_ACTIVE_TAB',

    RESET_DOCS_INSTANCES: 'CONFIG_RESET_DOCS_INSTANCES',
    UPDATE_DOCS_INSTANCES: 'CONFIG_UPDATE_DOCS_INSTANCES',

    RESET_FILES_VIEWS_PROJECTS: 'CONFIG_RESET_FILES_VIEWS_PROJECTS',
    RESET_DOCS_VIEWS_PROJECTS: 'CONFIG_RESET_DOCS_VIEWS_PROJECTS',
    RESET_EXEC_REPORTS_VIEWS_PROJECTS: 'CONFIG_RESET_EXEC_REPORTS_VIEWS_PROJECTS',
    RESET_CONFIG_REPORTS_VIEWS_PROJECTS: 'CONFIG_RESET_CONFIG_REPORTS_VIEWS_PROJECTS',
    RESET_WIZARD_VIEWS_PROJECTS: 'CONFIG_RESET_WIZARD_VIEWS_PROJECTS',
    RESET_DASHBOARD_VIEWS_PROJECTS: 'CONFIG_RESET_DASHBOARD_VIEWS_PROJECTS',


    GET_CONFIG_CUSTOMER_DATA_SUCCESS: 'CONFIG_GET_CONFIG_CUSTOMER_DATA_SUCCESS',
    UPDATE_CONFIG_CUSTOMER_DATA: 'CONFIG_UPDATE_CONFIG_CUSTOMER_DATA',

    ACTIVATE_CONFIG_CUSTOMER: 'CONFIG_ACTIVATE_CONFIG_CUSTOMER',
    DEACTIVATE_CONFIG_CUSTOMER: 'CONFIG_DEACTIVATE_CONFIG_CUSTOMER',

    UPDATE_CONFIG_CUSTOMER: 'CONFIG_UPDATE_CONFIG_CUSTOMER',
    RESET_CONFIG_SELECTED_CUSTOMER: 'CONFIG_RESET_CONFIG_SELECTED_CUSTOMER',

    SET_FILTER_STR: 'CONFIG_SET_FILTER_STR',
    SET_NEW_CUSTOMER_STATUS: 'CONFIG_SET_NEW_CUSTOMER_STATUS',
    SET_CUSTOMER_EDIT_MODE: 'CONFIG_SET_CUSTOMER_EDIT_MODE',

    INSERT_CONFIG_CUSTOMER: 'CONFIG_INSERT_CONFIG_CUSTOMER',

    RESET_CONFIG_NEW_CUSTOMER: 'CONFIG_RESET_CONFIG_NEW_CUSTOMER',
    UPDATE_CONFIG_NEW_CUSTOMER_DATA: 'CONFIG_UPDATE_CONFIG_NEW_CUSTOMER_DATA',

    TOGGLE_CUSTOMER_ACTIVE_TAB: 'CONFIG_TOGGLE_CUSTOMER_ACTIVE_TAB',

    TOGGLE_MODAL_CONFIRM: 'CONFIG_TOGGLE_MODAL_CONFIRM',
    SET_CONFIRM_DIALOG_HANDLER: 'CONFIG_SET_CONFIRM_DIALOG_HANDLER',

    TOGGLE_MODAL_EDIT_CONFIG_REPORT: 'CONFIG_TOGGLE_MODAL_EDIT_CONFIG_REPORT',

    GET_PLATFORMNAMES_SUCCESS: 'CONFIG_GET_PLATFORMNAMES_SUCCESS',

    TOGGLE_EXPAND_CUSTOMER: 'CONFIG_TOGGLE_EXPAND_CUSTOMER',

    SET_DEFAULT_SEARCH_PERIOD: 'CONFIG_SET_DEFAULT_SEARCH_PERIOD',

    FILTER_FILES_SEARCH_CUSTOMERS: 'CONFIG_FILTER_FILES_SEARCH_CUSTOMERS',
    FILTER_DOCUMENTS_SEARCH_CUSTOMERS: 'CONFIG_FILTER_DOCUMENTS_SEARCH_CUSTOMERS',

    CLEAR_FILTER_FILES_SEARCH_CUSTOMERS: 'CONFIG_CLEAR_FILTER_FILES_SEARCH_CUSTOMERS',
    CLEAR_FILTER_DOCUMENTS_SEARCH_CUSTOMERS: 'CONFIG_CLEAR_FILTER_DOCUMENTS_SEARCH_CUSTOMERS',
    
    TOGGLE_DOCS_VIEW_ACTIVE_TAB: 'CONFIG_TOGGLE_DOCS_VIEW_ACTIVE_TAB',
    SET_EXCEL_UPLOAD_YEAR: 'CONFIG_SET_EXCEL_UPLOAD_YEAR',
    
    SET_TAGS_OPTIONS: 'CONFIG_SET_TAGS_OPTIONS',

    GET_UPLOAD_LIST_REQUEST: "CONFIG_GET_UPLOAD_LIST_REQUEST",
    GET_UPLOAD_LIST_SUCCESS: "CONFIG_GET_UPLOAD_LIST_SUCCESS",
    GET_UPLOAD_LIST_FAILURE: "CONFIG_GET_UPLOAD_LIST_FAILURE",
    
    TOGGLE_MODAL_COPY_NEW_CONFIG_REPORT: "CONFIG_TOGGLE_MODAL_COPY_NEW_CONFIG_REPORT",

    GET_REPORTS_DESCS_REQUEST: "CONFIG_GET_REPORTS_DESCS_REQUEST",
    GET_REPORTS_DESCS_SUCCESS: "CONFIG_GET_REPORTS_DESCS_SUCCESS",

    GET_DOCUMENT_CHANNEL_DELIVERY_DATA: "CONFIG_GET_DOCUMENT_CHANNEL_DELIVERY_DATA",
    RESET_DOC_BOUNCEBACKS: "CONFIG_RESET_DOC_BOUNCEBACKS"
};